import React from "react";
import Nav from "../../components/nav";
import Footer from "../../components/footer";
import Workshopph from "../../assets/pic/workshop.jpg"
import {Helmet} from "react-helmet";

const WorkshopEn = ()=>{
    return(
        <div className='workshop-wrap'>
            <Helmet>
                <title>Holding training workshops</title>
                <meta name="description" content="Many online event platforms matured during this short period and equipped themselves with interesting interactive tools such as high-quality video and audio interaction, text conversation and interaction (chatting), sharing files and desktops, and displaying announcements." />
            </Helmet>
            <Nav/>
            <div className='webinar-dec'>
                <h1>Holding training workshops</h1>
                <img src={Workshopph} alt="Holding training workshops"/>
                <p>
                    One could say that the Covid19 pandemic has revolutionized education systems across the world and brought forth a new education system we would have faced in the far future to the year 2019. The main transformation in the educational system was the change from physical to virtual classes which underwent major progress in this short while.
                </p>
                <p>
                    Many online event platforms matured during this short period and equipped themselves with interesting interactive tools such as high-quality video and audio interaction, text conversation and interaction (chatting), sharing files and desktops, and displaying announcements.
                </p>
                <p>
                    These interactive tools lead to online events being held with great efficiency and quality, even higher than that of physical events.
                </p>
                <p>
                    Independence from the aspects of time and space is among the most important advantages of online events. Participants could be present in online events at any time of the day and from any geographical location given that online events are held in the context of the internet.
                </p>
                <p>
                    Holding a physical event will naturally limit you to a small statistical population (confined to the geographical location) while holding online events such as online workshops or classes is limitless and could serve your audience from any city or country.
                </p>
                <p>
                    BellMeet comprehensive online meeting platform is the only knowledge-based and native platform with the most advanced interactive tools that are mentioned as follows, and is prepared to host your online meetings and seminars:
                </p>
                <ul>
                    <li>•	High-quality audio interaction</li>
                    <li>•	High-quality video interaction with the possibility of multiple video connections</li>
                    <li>•	Playing videos online </li>
                    <li>•	Text conversation and interaction (chatting)</li>
                    <li>•	Sharing files</li>
                    <li>•	Sharing desktops</li>
                    <li>•	The possibility of displaying important announcements or messages in the meeting environment periodically</li>
                </ul>
                <p>
                    You can hold your private classes and training workshops using the BellMeet comprehensive platform periodically and with the highest quality possible.
                </p>
            </div>
            <Footer/>
        </div>
    )
}

export default WorkshopEn